import { Box, DialogTitle, IconButton, Slide, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as ModalCloseIcon } from "Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import { ReactComponent as AddDriver } from "Assets/Icons/PharmsmartIcon/AddDriver.svg";
import PrimaryIcon from "../PrimaryIcon";
// import PrimaryIcon from "Components/Common/PrimaryIcon";

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="bottom" ref={ref} {...props} />;
});

export const PrimaryDialogTitle = (props) => {
  const { title = "", handleClose, icon, surgerycreate } = props;
  return (
    <>
      <Box className="ModalHeading">
        <Box className="ModalIconWidth" textAlign={"center"}>
          {icon && (
            <PrimaryIcon icon={icon} color="white" className="FilterGreen" />
          )}
          {/* <AddDriver className="FilterGreen" /> */}
        </Box>
        <DialogTitle>
          <Typography className="TextBlack" textAlign={"center"} width={"100%"}>
            {" "}
            {title}{" "}
          </Typography>{" "}
          {typeof handleClose == "function" && (
            <IconButton
              onClick={() => handleClose()}
              className="ModalCloseIcon"
            >
              {" "}
              <PrimaryIcon
                className={surgerycreate ? "SurgerycancelIcon" : ""}
                icon={ModalCloseIcon}
              />{" "}
            </IconButton>
          )}
        </DialogTitle>
      </Box>
    </>
  );
};
